import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { observable } from 'mobx';
import { HyperSpaceTreeMapWidgetOptions } from './types';
import { MetaInfoOptions, MetricGroupOptions } from '@sprinklr/stories/hyperspaceWidgets/types';

export class HyperSpaceTreeMapWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceTreeMapWidgetOptions {
    @observable labelSize = 30;
    @observable labelEnable = true;

    @observable metricGroupOptions: MetricGroupOptions = {
        enabled: true,
        disablePercentChangeOption: true,
        metric: {
            size: 35,
            enabled: true,
            format: {
                decimals: 2,
                useShortened: true,
            },
        },
        metricName: {
            size: 20,
            enabled: true,
        },
        percentChange: {
            size: 20,
            enabled: false,
        },
    };
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };
}
